import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Box from "../../../components/Box";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import Content from "../../../_metronic/layout/components/content/Content";
import { ToolbarWrapper } from "../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../_metronic/layout/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../components/CustomSingleSelect";
import { ConstantService } from "../../../services/ConstantService";
import { storeActivityIndicator } from "../../../redux/reducers/authSlice";
import toast from "react-hot-toast";
import { CaseService } from "../../../services/CaseService";
import { GetCaseListResponse } from "../../../models/response/case/GetCaseListResponse";
import { BankAccountService } from "../../../services/BankAccountService";
import { GetBankAccountListResponse } from "../../../models/response/bankAccount/GetBankAccountListResponse";
import CustomSwitch from "../../../components/CustomSwitch";
import { BankAccountTransactionMatchDefinitionService } from "../../../services/BankAccountTransactionMatchDefinitionService";
import { Helpers } from "../../../helpers/Helpers";
import { AddBankAccountTransactionMatchDefinitionResponse } from "../../../models/response/bankAccountTransactionMatchDefinition/AddBankAccountTransactionMatchDefinitionResponse";
import { GetBankAccountTransactionMatchDefinitionByIdResponse } from "../../../models/response/bankAccountTransactionMatchDefinition/GetBankAccountTransactionMatchDefinitionByIdResponse";
import { GetConstantListResponse, GetConstantListResponseItem } from "../../../models/response/constant/GetConstantListResponse";

const BankAccountTransactionMatchDefinitionAdd = () => {
    const navigate = useNavigate();
    const pageName = "Ayarlar > Banka H. Eşleşme"
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();

    const [bankAccountTransactionMatchDefinitionId, setBankAccountTransactionMatchDefinitionId] = useState<string | undefined>(undefined);

    const [selectedBank, setSelectedBank] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [transactionId, setTransactionId] = useState<string | undefined>(undefined);
    const [selectedCaseMovementType, setSelectedCaseMovementType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedCustomForm, setSelectedCustomForm] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedCurrencyType, setSelectedCurrencyType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedAccount, setSelectedAccount] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [desc, setDesc] = useState<string | undefined>(undefined);
    const [isCustomer, setIsCustomer] = useState(false);
    const [isSupplier, setIsSupplier] = useState(false);
    const [isAgency, setIsAgency] = useState(false);
    const [isCustomActive, setIsCustomActive] = useState(true);

    const [accountList, setAccountList] = useState<CustomSingleSelectModel[]>([]);

    useEffect(() => {
        var id = searchParams.get("id");
        getData(id);
    }, [])

    const getCustomForms = async () => {
        try {
            dispatch(storeActivityIndicator(true));
            var response: GetConstantListResponse = await ConstantService.getConstantList('CUSTOM_FORM')

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            var allCustomForms = response.data;
            var customForms: GetConstantListResponseItem[] = [];

            allCustomForms.forEach((item) => {
                var control = allCustomForms.find(x => x.parentConstantId == item.constantId);

                if (!control)
                    customForms.push(item);
            })

            customForms.forEach((item) => {
                var textList: string[] = []

                var parent = allCustomForms.find(x => x.constantId == item.parentConstantId);

                while (parent) {
                    textList.push(parent.value);
                    parent = allCustomForms.find(x => x.constantId == parent?.parentConstantId);
                }

                textList = textList.reverse();

                item.value = textList.join(" > ") + " > " + item.value;
            })

            customForms = customForms.sort((x, y) => x.value.localeCompare(y.value));

            return { isSuccess: true, data: customForms };
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const getData = async (_id: string | undefined | null = undefined) => {
        try {
            dispatch(storeActivityIndicator(true));

            var itemList: CustomSingleSelectModel[] = []

            var response2: GetCaseListResponse = await CaseService.getCaseList();

            if (!response2.isSuccess) {
                toast.error(response2.message)
                return;
            }

            itemList = [...itemList, ...response2.data.map(function (x) {
                return { label: x.name, value: x.caseId, additionalValue1: 'C' }
            })];

            var response3: GetBankAccountListResponse = await BankAccountService.getBankAccountList();

            if (!response3.isSuccess) {
                toast.error(response3.message)
                return;
            }

            itemList = [...itemList, ...response3.data.map(function (x) {
                return { label: x.name, value: x.bankAccountId, additionalValue1: 'B' }
            })];

            setAccountList(itemList);

            var id = _id ? _id : searchParams.get("id") ? searchParams.get("id") : undefined;

            if (id) {
                var response: GetBankAccountTransactionMatchDefinitionByIdResponse = await BankAccountTransactionMatchDefinitionService.getBankAccountTransactionMatchDefinitionById(id);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setBankAccountTransactionMatchDefinitionId(response.data.bankAccountTransactionMatchDefinitionId);

                if (response.data.bankId && response.data.bankName)
                    setSelectedBank({ label: response.data.bankName, value: response.data.bankId });

                setTransactionId(response.data.transactionId);

                if (response.data.debtOrReceivable) {
                    var response4: GetConstantListResponse = await ConstantService.getConstantList('CASE_MOVEMENT_TYPE', undefined, response.data.debtOrReceivable == "A" ? "1" : "2");

                    if (!response4.isSuccess) {
                        toast.error(response4.message)
                        return;
                    }

                    if (response4.data.length > 0) {
                        setSelectedCaseMovementType({ label: response4.data[0].value, value: response4.data[0].constantId, additionalValue1: response4.data[0].additionalValue1 });
                    }
                }

                if (response.data.customFormId && response.data.customFormName)
                    setSelectedCustomForm({ label: response.data.customFormName, value: response.data.customFormId });

                if (response.data.currencyTypeId && response.data.currencyTypeName)
                    setSelectedCurrencyType({ label: response.data.currencyTypeName, value: response.data.currencyTypeId });

                if (response.data.defaultAccount && (response.data.defaultBankAccountId || response.data.defaultCaseId))
                    setSelectedAccount({ label: response.data.defaultAccount, value: response.data.defaultBankAccountId ? response.data.defaultBankAccountId : response.data.defaultCaseId, additionalValue1: response.data.defaultBankAccountId ? "B" : "C" })

                setDesc(response.data.description);

                setIsCustomer(response.data.isCustomer);
                setIsSupplier(response.data.isSupplier);
                setIsAgency(response.data.isAgency);

                setIsCustomActive(response.data.isCustomActive);
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }
    const saveBankAccountTransactionMatchDefinition = async () => {
        try {
            if (!selectedBank)
                toast.error('Banka alanını doldurunuz!')
            else if (!selectedCustomForm)
                toast.error('Eşleşme Tipi alanını doldurunuz!')
            else if (!selectedCaseMovementType)
                toast.error('Hareket Tipi alanını doldurunuz!')
            else if (!transactionId || Helpers.isEmpty(transactionId))
                toast.error('Transaction Id alanını doldurunuz!')
            else {
                dispatch(storeActivityIndicator(true));

                var response: AddBankAccountTransactionMatchDefinitionResponse = await BankAccountTransactionMatchDefinitionService.addBankAccountTransactionMatchDefinition({
                    bankAccountTransactionMatchDefinitionId: bankAccountTransactionMatchDefinitionId,
                    bankId: selectedBank.value,
                    currencyTypeId: selectedCurrencyType?.value,
                    customFormId: selectedCustomForm.value,
                    debtOrReceivable: selectedCaseMovementType.additionalValue1 == "1" ? "A" : "B",
                    description: desc,
                    isAgency: isAgency ? 1 : 0,
                    isCustomer: isCustomer ? 1 : 0,
                    isCustomActive: isCustomActive ? 1 : 0,
                    isSupplier: isSupplier ? 1 : 0,
                    transactionId: transactionId,
                    defaultBankAccountId: selectedAccount ? selectedAccount.additionalValue1 == "B" ? selectedAccount.value : undefined : undefined,
                    defaultCaseId: selectedAccount ? selectedAccount.additionalValue1 == "C" ? selectedAccount.value : undefined : undefined,
                });

                if (!response.isSuccess) {
                    toast.error(response.message);
                    dispatch(storeActivityIndicator(false));
                    return;
                }

                toast.success(response.message)

                dispatch(storeActivityIndicator(false));
                navigate(Helpers.getGoBackUrl())
            }
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join('> ') + '> ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <div>
                        <KTCard className="ebbe-card">
                            <KTCardBody>
                                <h4 className="mb-10 text-black">Genel Bilgiler</h4>

                                <div className="row">
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Banka Adı</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedBank}
                                            onChange={setSelectedBank}
                                            onMenuOpen={() => ConstantService.getConstantList('BANK')}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Transaction Id</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={transactionId} onChange={(e) => setTransactionId(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Hareket Tipi</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedCaseMovementType}
                                            onChange={setSelectedCaseMovementType}
                                            onMenuOpen={() => ConstantService.getConstantList('CASE_MOVEMENT_TYPE')}
                                            labelName='value'
                                            valueName='constantId'
                                            additionalValue1Name="additionalValue1"
                                        />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Eşleşme Tipi</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedCustomForm}
                                            onChange={setSelectedCustomForm}
                                            onMenuOpen={() => getCustomForms()}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Banka H. Döviz Cinsi</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedCurrencyType}
                                            onChange={setSelectedCurrencyType}
                                            onMenuOpen={() => ConstantService.getConstantList('CURRENCY', undefined, undefined)}
                                            labelName='additionalValue1'
                                            valueName='constantId'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Hesap</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedAccount}
                                            onChange={setSelectedAccount}
                                            onMenuOpen={async () => {
                                                return {
                                                    isSuccess: true,
                                                    data: accountList
                                                }
                                            }}
                                            labelName='label'
                                            valueName='value'
                                            additionalValue1Name="additionalValue1"
                                        />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Açıklama</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={desc} onChange={(e) => setDesc(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>

                                    <div className="col-md-8">
                                        <Box flexDirection="row">
                                            <Box flex={1}>
                                                <label htmlFor="exampleFormControlInput1" className="form-label">Müşteri</label>

                                                <CustomSwitch isActive={isCustomer} setIsActive={setIsCustomer} />
                                            </Box>

                                            <Box flex={1}>
                                                <label htmlFor="exampleFormControlInput1" className="form-label">Tedarikçi</label>

                                                <CustomSwitch isActive={isSupplier} setIsActive={setIsSupplier} />
                                            </Box>

                                            <Box flex={1}>
                                                <label htmlFor="exampleFormControlInput1" className="form-label">Acente</label>

                                                <CustomSwitch isActive={isAgency} setIsActive={setIsAgency} />
                                            </Box>

                                            <Box flex={1}>
                                                <label htmlFor="exampleFormControlInput1" className="form-label">Aktif</label>

                                                <CustomSwitch isActive={isCustomActive} setIsActive={setIsCustomActive} />
                                            </Box>
                                        </Box>
                                    </div>

                                </div>
                            </KTCardBody>
                        </KTCard>
                    </div>

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box mr="15px">

                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                </Box>
                                <Box>
                                    <button className="btn btn-primary btn-sm" onClick={saveBankAccountTransactionMatchDefinition}>Kaydet</button>
                                </Box>
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>
        </React.Fragment>
    )
}

export default BankAccountTransactionMatchDefinitionAdd;